;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('refresher', refresher)

  function refresher () {
    function controller ($scope, $transclude, $attrs, $element) {
      var childScope

      $scope.$watch($attrs.condition, function (value) {
        $element.empty()
        if (childScope) {
          childScope.$destroy()
          childScope = null
        }

        $transclude(function (clone, newScope) {
          childScope = newScope
          $element.append(clone)
        })
      })
    }

    return {
      transclude: true,
      controller
    }
  }
})()
